import TextLink from 'LuxKit/TextLink'
import BodyText from 'LuxKit/Typography/BodyText'
import withMountGuard from 'hocs/withMountGuard'
import { useAppSelector } from 'hooks/reduxHooks'
import { LOYALTY_LANDING_PAGE } from 'loyalty/constants/loyaltyRoutes'
import getIsLoyaltyEnabled from 'loyalty/selectors/getIsLoyaltyEnabled'
import getLoyaltyDisplayTier from 'loyalty/selectors/getLoyaltyDisplayTier'
import getLoyaltyNextTier from 'loyalty/selectors/getLoyaltyNextTier'
import getLoyaltyTierDisplayName from 'loyalty/selectors/getLoyaltyTierDisplayName'
import { useCallback } from 'react'
import * as React from 'react'
import { FormattedMessage } from 'react-intl'

interface Props {
  onLinkClick: () => void
}

function LuxPlusManageAccountModalLoyaltyBenefitsBlob({ onLinkClick }: Props) {
  const tier = useAppSelector(getLoyaltyDisplayTier)
  const nextTier = useAppSelector(getLoyaltyNextTier)
  const renderLink = useCallback((chunks: React.ReactNode) => <TextLink to={`/${LOYALTY_LANDING_PAGE}`} onClick={onLinkClick}>{chunks}</TextLink>, [onLinkClick])

  return <BodyText variant="medium">
    {(tier === 'bronze' && nextTier) && <FormattedMessage
      id="JrOJFNssGEIu0atJZGuN"
      defaultMessage="Bringing you a step closer to {tierName} status where you can enjoy free airport lounge passes, discounted travel protection <link>& more</link>"
      description="Bronze tier loyalty benefit description with link for LuxPlus+ members"
      values={{
        tierName: getLoyaltyTierDisplayName(nextTier),
        link: renderLink,
      }}
    />}
    {(tier === 'silver' && nextTier) && <FormattedMessage
      id="wSayz6XNBbzeQ6wF18Js"
      defaultMessage="Boosting your progress to {tierName} status, giving you access to guaranteed free room upgrades, chauffeur airport transfers <link>& more</link>"
      description="Silver tier loyalty benefit description with link for LuxPlus+ members"
      values={{
        tierName: getLoyaltyTierDisplayName(nextTier),
        link: renderLink,
      }}
    />}
    {(tier === 'gold' && nextTier) && <FormattedMessage
      id="jpF8yfZa2ege5sy0lHJI"
      defaultMessage="Boosting your progress to {tierName} status, giving you access to unlimited chauffeur airport transfers, guaranteed free room upgrades <link>& more</link>"
      description="Gold tier loyalty benefit description with link for LuxPlus+ members"
      values={{
        tierName: getLoyaltyTierDisplayName(nextTier),
        link: renderLink,
      }}
    />}
    {tier === 'platinum' && <FormattedMessage
      id="gNxGpI0Lmu3HMmvtKi03"
      defaultMessage="Helping retain your Platinum status, and your access to unlimited chauffeur airport transfers, guaranteed free room upgrades <link>& more</link>"
      description="Platinum tier loyalty benefit description with link for LuxPlus+ members"
      values={{
        link: renderLink,
      }}
    />}
  </BodyText>
}

export default withMountGuard(() => {
  return useAppSelector(getIsLoyaltyEnabled)
})(LuxPlusManageAccountModalLoyaltyBenefitsBlob)
